export default __webpack_public_path__ + "238e375048f18665be798d70428bc917.png";